import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import axios from "axios";
import { MdWavingHand } from "react-icons/md";
import ClientWelcome from '../images/profile/client_welcome.svg';
import { buildApiUrl } from "../utils/api";

function ClientDetails() {
    const [warehouseName, setWarehouseName] = useState('');

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) return;

                const res = await axios.get(buildApiUrl('/api/client/clientDetail'), {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (res.data?.user) {
                    setWarehouseName(res.data.user.warehouseName || '');
                }
            } catch (error) {
                console.error('Error fetching client details:', error);
            }
        };

        fetchUserDetails();
    }, []);

    return (
        <>
            <Helmet>
                <title>Client Dashboard | 3PL Search</title>
            </Helmet>
            <div className="clientDetail p-3">
                <h2>Welcome, {warehouseName || "Provider"} <MdWavingHand style={{ color: "#E0A75E" }} /></h2>
                <p className="text-muted mb-4">Manage your warehouse listing and review inbound quote requests from buyers.</p>

                <div className="row g-3 mb-4">
                    <div className="col-sm-6 col-md-4">
                        <Link to="/clientDetails/requestDetail" style={{ textDecoration: "none" }}>
                            <div className="card h-100 border-0 shadow-sm p-3 text-center">
                                <h5 style={{ color: "#132238" }}>Incoming Requests</h5>
                                <p className="text-muted small">View buyers who have requested a quote for your warehouse.</p>
                            </div>
                        </Link>
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <Link to="/contact" style={{ textDecoration: "none" }}>
                            <div className="card h-100 border-0 shadow-sm p-3 text-center">
                                <h5 style={{ color: "#132238" }}>Contact CS Team</h5>
                                <p className="text-muted small">Get support for onboarding, updates, or listing changes.</p>
                            </div>
                        </Link>
                    </div>
                </div>

                <div className="welcomeImage text-center" style={{ opacity: 0.6, maxWidth: "400px" }}>
                    <img src={ClientWelcome} alt="client welcome" style={{ width: "100%" }} />
                </div>
            </div>
        </>
    );
}

export default ClientDetails;
